import {combineReducers} from '@reduxjs/toolkit';
import information from './informationSlice';

const reducers = combineReducers({
    information
});

export default reducers;
